import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    subscriptionId: String
  }

  initialize() {
    this.loadJobs = this.loadJobs.bind(this);
  }

  connect() {
    this.element.addEventListener('shown.bs.modal', this.loadJobs());
  }

  disconnect() {
    this.element.removeEventListener('shown.bs.modal', this.loadJobs());
  }

  loadJobs() {
    const frame = this.element.querySelector('turbo-frame#scheduled_jobs');
    if (frame && !frame.hasAttribute('src')) {
      frame.src = `/admin/subscriptions/${this.subscriptionIdValue}/scheduled_jobs`;
    }
  }
}
